'use client'

import { useState } from 'react'

/**
 * Client-side companion to the server-side embed-source cookie.
 *
 * On first load the middleware sets the cookie when `?source=zalo` is present.
 * This hook reads the same cookie so client components (like the landing page)
 * can react to the embedded state without a server round-trip.
 *
 * For layout-level hiding (no flash), prefer reading the cookie in a Server
 * Component and passing it as a prop — see `[locale]/layout.tsx`.
 */
export function useZaloEmbedded(): boolean {
  const [isEmbedded] = useState(() => {
    if (typeof document === 'undefined') return false
    return document.cookie
      .split(';')
      .some((c) => c.trim() === 'embed-source=zalo')
  })

  return isEmbedded
}
